import { request, upload } from './client';
import type { CustomerImportCommit, CustomerImportPreview, CustomerImportResult } from '@kassa/shared';

const BASE = '/api/customers/import';

export const customerImportApi = {
  customerImportPreview: (file: File) => upload<CustomerImportPreview>(`${BASE}/preview`, file),
  customerImportCommit: (body: CustomerImportCommit) => request<CustomerImportResult>('POST', `${BASE}/commit`, body),
  customerImportReverse: (docId: string) =>
    request<{ id: string; reversalId: string }>('POST', `${BASE}/${encodeURIComponent(docId)}/reverse`),
};
